import { ParameterSubjectType } from '@/types/parameterTypes';
import { useStepHasDisabledStatus } from './useStepHasDisabledStatus';
import { useTreeStore } from '../store/TreeStore';

export function useSubjectIsDisabled(subjectId: string, subjectType: ParameterSubjectType) {
  let stepId = subjectId;

  if (subjectType === ParameterSubjectType.OPERATION) {
    const containerLookup = useTreeStore((state) => state.containerLookup);
    const operation = useTreeStore((state) => state.operations.find((op) => op.id === subjectId));
    const scenario = containerLookup[operation?.parentId || ''];
    const step = containerLookup[scenario?.parentId || ''];
    stepId = step.id;
  }

  return useStepHasDisabledStatus(stepId);
};
